import React, { useEffect } from 'react';
import Checkbox from '../../../shared/forms/Checkbox';
import Modal, { ModalCloseButton } from '../../../shared/modals/Modal';
import { useMessage } from '../../../contexts/MessageContext';
import { ReactComponent as Spinner } from '../../../assets/icons/spinner.svg';

const DownloadInvoicesModal = ({setInvoicesModalVisible}) => {
  const showMessage = useMessage();
  const [invoices, setInvoices] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [downloading, setDownloading] = React.useState(false);
  const closeModal = () => setInvoicesModalVisible(false);

  useEffect(() => {
    fetch(process.env.REACT_APP_SERVER_URL + '/api/get-invoice-list', {
      method: 'POST',
      headers: {
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          setInvoices(data.list.map((inv) => {
            return {...inv, checked: false};
          }).reverse());

          setLoading(false);
        }
      })

  }, []);

  const handleDownload = (names) => {
    setDownloading(true);

    fetch(process.env.REACT_APP_SERVER_URL + '/api/get-invoice-files', {
      method: 'POST',
      headers: {
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ names }),
    })
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        const filename = names.length === 1
          ? names[0].replace('Invoice ', 'invoice_') + '.pdf'
          : 'invoices.zip';

        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();

        closeModal();
        showMessage(`${names.length === 1 ? 'Invoice' : 'Invoices'} saved to file ${filename}.`);
      })
      .catch(error => {
        console.error('Download failed:', error);
      });
  };

  const canDownload = () => invoices.some((inv) => inv.checked);

  return (
    <Modal isOpen={true} onClose={closeModal}>
      <div className='modal'>
        <div className='modal__header'>
          <h3 className='margin-none'>Invoices</h3>
          <ModalCloseButton
            onClick={closeModal}
            label="Close invoices modal"
          />
        </div>

        <div className="modal__body">
          <h4 className="margin-none">Select to download</h4>

          {loading && (
            <div className="simple-row center">
              <Spinner className="modal-submit-spinner" />
              <p className="margin-none">Loading...</p>
            </div>
          )}

          {!loading && (
            <table className='padding-b'>
              <tbody>
                <tr>
                  <td style={{visibility: 'hidden'}} />
                  <td>Name</td>
                  <td>Date</td>
                  <td>Size</td>
                </tr>

                <tr>
                  <td>
                    <Checkbox
                      checked={invoices.every((inv) => inv.checked)}
                      onChange={(e) => {
                        setInvoices(invoices.map((inv) => {
                          return {...inv, checked: e.target.checked};
                        }))}} />
                  </td>
                  <td colSpan={3}>All invoices</td>
                </tr>

                {invoices.map((invoice, index) => {
                  return (
                    <tr>
                      <td key={index}>
                        <Checkbox checked={invoice.checked}
                                  onChange={() => {
                                    setInvoices(invoices.map((inv, i) => {
                                      if (i === index) {
                                        return {...inv, checked: !inv.checked};
                                      }
                                      return inv;
                                    }));
                                  }} />
                      </td>
                      <td>{invoice.name}</td>
                      <td>{invoice.date}</td>
                      <td>{invoice.size}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>

        <div className='modal__footer'>
          <button className="btn secondary"
                  onClick={() => {
                    closeModal();
                  }}>
            Cancel
          </button>
          <button className="btn primary"
                  type="button"
                  disabled={!canDownload() || downloading}
                  onClick={() => {
                    if (canDownload()) {
                      let names = invoices.filter((inv) => inv.checked).map((inv) => inv.name);
                      handleDownload(names);
                    }
                  }}>
            {downloading && <Spinner className="icon sm" />}
            Download
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default DownloadInvoicesModal;
